import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h1>AWS Serverless hosting of a static (gatsby) website via CICD</h1>
    <p>
      Welcome to the static website hosting CICD test area. a Code pipeline
      initiates a build and deployment to test.sandstorm.nl and will coexist
      next to other CodePipelines. Some resources are shared via the Sandstorm
      InfraStack to keep AWS deployment &amp; troubleshooting efficient.
    </p>
    <p>
      Website code is developed in a VDI environment. The VDI environment allows
      local testing and verification. Source code is versioned by pushing it to
      GitHub. AWS CodePipeline will notice an updated Github repo, download it,
      and follow build instructions to create the static website and deploy its
      code accordingly.
    </p>
    <p>
      The IAC template takes care of setting up a superfast and secure website
      via CloudFront (CDN) distribution. It also adds SSL Certificates and
      creates/glues domainnames if the zone is available in Route53: e.g.
      example.com and www.example.com. The final work being tested here started
      to integrate with Gatsby websites being deployed via CICD. but since
      Gatsby has grown too complex overtime I have now focussed on JAM stack.
      Next to Gatsby it now facilitates an "universal" approach for other
      websites like Bootstrap still taking advantage of versioning via Github.
    </p>
    <p>
      Static websites are simple to maintain but are fast and secure. You can
      add dynamic content by having the website interact with other services
      through APIs. Awesome!
    </p>
    <p>
      Have a look at some production sites here:{" "}
      <a href="https://www.kapsalonpink.com" alt="" target="_blank">
        kapsalonpink
      </a>{" "}
      |{" "}
      <a href="https://www.frankbrons.nl" alt="" target="_blank">
        goudsmid frankbrons
      </a>{" "}
      |{" "}
      <a href="https://www.jvhwestland.nl" alt="" target="_blank">
        jvh techniek westland
      </a>{" "}
      or{" "}
      <a href="https://www.sandstorm.nl" alt="" target="_blank">
        sandstorm main website
      </a>
    </p>
    <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
      <Image />
    </div>
    <Link to="/page-2/">Go to page 2</Link>
    <div class="test">hello world again</div>
  </Layout>
)

export default IndexPage
